import { useContext } from 'react';

import { useTranslationWithPrefix } from '@hotjar/translations';
import { PlanComparisonColumnsContext } from '@hotjar/webapp/features/Billing/PlanComparisonColumns/utils';

interface UsePlanColumnTagProps {
  isRecommendedPlanInCurrentFeatureGroup: boolean;
}

/**
 * Determines a tag text to show for a plan column in the plan comparison modal.
 */
export const usePlanColumnTag = ({
  isRecommendedPlanInCurrentFeatureGroup,
}: UsePlanColumnTagProps): string | null => {
  const { t } = useTranslationWithPrefix('revenue:plan-comparison-modal');
  const { isUpgradeRequest } = useContext(PlanComparisonColumnsContext);

  if (isUpgradeRequest && isRecommendedPlanInCurrentFeatureGroup) {
    return t('requested-plan');
  }

  if (isRecommendedPlanInCurrentFeatureGroup) {
    return t('recommended');
  }

  return null;
};
